
import { BaseService } from "core/services";
import { PickTicketDetailRouteService } from "application/pick-ticket/services";

class PickTicketDetailService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PickTicketDetailRouteService());
	}

	updateBackOrder(resource) {
		const url = this.routeService.updateBackOrder(resource);

		return this.apiClient.put(url, resource);
	}

	updateSendSeparatelyQty(resource) {
		const url = this.routeService.updateSendSeparatelyQty(resource);
		return this.apiClient.put(url, resource);
	}
}

export default PickTicketDetailService;